module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/13-ceea68d495e63aa1d43b288948a02ceb.png";